import PersonIcon from "@mui/icons-material/Person";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import React from "react";

interface PatientCardProps {
  patient: {
    person_id: string;
    given_name?: string;
    family_name?: string;
    gender?: string;
  };
  onClick?: () => void;
}

const getGenderPrefix = (gender: string | undefined) => {
  if (!gender) return "";
  const lowerGender = gender.toLowerCase();
  if (lowerGender.includes("male") && !lowerGender.includes("female")) return "M.";
  if (lowerGender.includes("female")) return "Mme.";
  return ""; // For other genders, no prefix
};

export const PatientCard: React.FC<PatientCardProps> = ({ patient, onClick }) => (
  <Stack
    direction="row"
    spacing={1}
    alignItems="center"
    sx={{
      p: 1,
      borderRadius: "sm",
      cursor: onClick ? "pointer" : "default",
      "&:hover": onClick
        ? {
            backgroundColor: "background.level1",
          }
        : {},
    }}
    onClick={onClick}
  >
    <PersonIcon sx={{ fontSize: "1rem", color: "text.secondary" }} />
    <Typography level="body-sm" sx={{ flex: 1 }}>
      {getGenderPrefix(patient.gender)} {patient.given_name} {patient.family_name}
    </Typography>
  </Stack>
);
